import { useCallback, useEffect } from "react";
import debounce from "lodash/debounce";
import { reportUserAction, getToken, fetchToken } from "./service";
import { findClosesElement } from "../utils/dom";

const extensionKeyReg = /^tk(\d{1,2})$/;

enum EEventTriggerType {
  click = "click",
  mouseover = "mouseover",
}

const useTraceLog = () => {
  const initToken = () => {
    const token = getToken();
    if (!token) {
      fetchToken();
    }
  };

  const validTrigger = (
    currentTarget: HTMLElement,
    type: EEventTriggerType,
  ) => {
    if (
      (currentTarget?.dataset?.tt === "click" || !currentTarget?.dataset?.tt) &&
      type === EEventTriggerType.click
    ) {
      return true;
    }
    if (
      currentTarget?.dataset?.tt === "hover" &&
      type === EEventTriggerType.mouseover
    ) {
      return true;
    }
    return false;
  };

  const dispatchDataset = (e: Event, type: EEventTriggerType) => {
    const target = e.target as HTMLElement | null;
    const currentTarget = findClosesElement(target, dom => !!dom.dataset.ti);
    if (currentTarget) {
      if (validTrigger(currentTarget, type)) {
        const { ti = "", tn = "" } = currentTarget.dataset;
        const extension: { [key: string]: string } = Object.keys(
          currentTarget.dataset,
        )
          .filter(item => extensionKeyReg.test(item))
          .reduce(
            (acc, key) => {
              const value = currentTarget.dataset[key];
              if (value !== undefined) {
                const serial = key.match(extensionKeyReg)?.[1];
                acc[value] = currentTarget.dataset[`tv${serial}`] ?? "";
              }
              return acc;
            },
            {} as { [key: string]: string },
          );
        extension.current_page = location.pathname;
        const payload = {
          eventName: tn,
          eventId: ti,
          eventExtension: extension,
        };
        reportUserAction(payload);
      }
    }
  };

  const handleClick = useCallback(
    debounce((e: Event) => {
      dispatchDataset(e, EEventTriggerType.click);
    }, 300),
    [],
  );

  const handleMouseOver = useCallback(
    debounce((e: Event) => {
      dispatchDataset(e, EEventTriggerType.mouseover);
    }, 300),
    [],
  );

  useEffect(() => {
    initToken();
  }, []);

  useEffect(() => {
    window.document.addEventListener("click", handleClick);
    return () => {
      window.document.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(() => {
    window.document.addEventListener("mouseover", handleMouseOver);
    return () => {
      window.document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  return [];
};

export default useTraceLog;
